<template>
  <v-btn icon variant="text" density="comfortable">
    <v-icon class="text-medium-emphasis">mdi-dots-vertical</v-icon>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * KebabButton — the shared three-dots ("kebab") activator button.
 *
 * The flat (variant="text"), medium-emphasis-grey icon button that triggers every action
 * menu in the app. Extracted so the button is defined ONCE instead of being duplicated in
 * ~48 *Menu components. Used two ways:
 *   - inside <ActionMenu> (the wrapper for the simple row menus), and
 *   - directly in the bespoke title-bar menus that keep their own <v-menu>.
 *
 * Always sits in a v-menu #activator slot, forwarding the activator props:
 *   <template #activator="{ props }">
 *     <KebabButton v-bind="props" :disabled="…" />
 *   </template>
 * The activator props, :disabled, aria attrs and handlers fall through to the <v-btn>.
 *
 * Colour: V2's icon-button glyph was medium-emphasis grey (rgba(0,0,0,.54)), NOT black.
 * `text-medium-emphasis` restores that and stays theme-aware (flips to light in dark mode),
 * unlike V3's default which renders the icon at full (near-black) emphasis.
 *
 * Size: V2's `<v-btn icon>` was 36x36. V3 sizes an icon button as
 * `--v-btn-height + 12px` at the default density, i.e. 36 + 12 = 48 — noticeably
 * chunkier, and in a TableCard row it widened the whole action column (68 -> 80px).
 * `density="comfortable"` is the +0px step, giving exactly 36x36 back. Density (not
 * `size`) is the right lever here: `size` would also shrink `--v-btn-height` and with
 * it the 24px glyph, which already matches V2.
 */
export default defineComponent({
  name: 'KebabButton',
})
</script>
